export const parser_get_email_notification_list = (response) => {
    try {
        if (response?.data) {
            response = response.data;
        }
        if (!response) {
            return {};
        }
        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const parser_create_email_notification = (response) => {
    try {
        if (response?.data) {
            response = response.data;
        }
        if (!response) {
            return {};
        }
        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const parser_update_email_notification = (response) => {
    try {
        if (response?.data) {
            response = response.data;
        }
        if (!response) {
            return {};
        }
        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const parser_activate_deactivate_email_notification = (response) => {
    try {
        if (response?.data) {
            response = response.data;
        }
        if (!response) {
            return {};
        }
        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const parser_get_email_notification_details = (response) => {
    try {
        if (response?.data) {
            response = response.data;
        }
        if (!response) {
            return {};
        }
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
